<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="sounds-of-the-night">
<h1>Sounds of the Night</h1>
<p style="text-indent: 00em;">As the afternoon light starts to fade</p>
<p style="text-indent: 00em;">And the low evening sun creates more shade</p>
<p style="text-indent: 00em;">The birdies squawk as they fly off to roost</p>
<p style="text-indent: 00em;">And the noise from the trees gets an incredible boost</p>
<p style="text-indent: 00em;">They jostle and fight to find some space</p>
<p style="text-indent: 00em;">That will be their special roosting place</p><br/>
<p style="text-indent: 00em;">The crickets make themselves well heard</p>
<p style="text-indent: 00em;">And with the cicadas the racket is quite absurd</p>
<p style="text-indent: 00em;">I hear the magpies give their last cry of the night</p>
<p style="text-indent: 00em;">As they also look for a place that’s just right</p><br/>
<p style="text-indent: 00em;">There’s barking down the street, a small dog</p>
<p style="text-indent: 00em;">Oh no! We have captured in our trap, a hog</p>
<p style="text-indent: 00em;">Luckily only by its toes</p>
<p style="text-indent: 00em;">So, we release it quickly and away it goes</p><br/>
<p style="text-indent: 00em;">Then the noise quietens down, there’s an owl hooting out there</p>
<p style="text-indent: 00em;">His frantic mating call is filling the air</p>
<p style="text-indent: 00em;">A delivery truck roars up the road every night</p>
<p style="text-indent: 00em;">To the rest-home to leave his load, I think that is right</p><br/>
<p style="text-indent: 00em;">As we drift off to sleep, listening to the rain</p>
<p style="text-indent: 00em;">The roar of a motorbike awakens us again</p>
<p style="text-indent: 00em;">So, we toss and turn and talk a bit</p>
<p style="text-indent: 00em;">The wariness has gone now, damn it!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?2e5759de